// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/react-id-swiper/swiper.min.css
// module id = 981
// module chunks = 0